import { Link } from "react-router-dom";
import { ChevronRight, LayoutGrid } from "lucide-react";

const hubLinkClass =
  "flex items-center justify-between rounded-md px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-white/10";

export function CrmSettingsHubPage() {
  const sectionLinks = [
    ["roles", "Users & Roles"],
    ["permissions", "Permissions"],
    ["lead-forms", "Lead Forms"],
    ["schedules", "Schedules"],
    ["functions", "Functions"],
    ["modules", "Modules"],
    ["history", "History"],
    ["usage", "Usage"],
  ] as const;

  return (
    <div className="mx-auto flex min-h-0 w-full max-w-7xl flex-1 flex-col gap-4 overflow-y-auto px-4 py-5">
      <p className="text-xs leading-relaxed text-slate-500 dark:text-slate-400">
        CRM setup. Choose a section from the sidebar or the links below.
      </p>
      <div className="max-w-md rounded-xl border border-slate-200/90 bg-white shadow-sm dark:border-white/10 dark:bg-zinc-950">
        <div className="space-y-1 px-4 pb-2 pt-4">
          <h2 className="text-sm font-semibold tracking-tight text-slate-900 dark:text-white">CRM</h2>
          <p className="text-xs leading-snug text-slate-500 dark:text-slate-400">
            Users, permissions, modules, and automation for this app.
          </p>
        </div>
        <div className="flex flex-col gap-px px-3 pb-3 pt-0">
          {sectionLinks.map(([tab, label]) => (
            <Link
              key={tab}
              to={tab === "modules" ? "/crm/settings/modules" : `/crm/settings?view=section&tab=${tab}`}
              className={hubLinkClass}
            >
              <span>{label}</span>
              <ChevronRight className="size-3.5 shrink-0 text-slate-400" aria-hidden />
            </Link>
          ))}
        </div>
      </div>
      <Link
        to="/settings"
        className="inline-flex w-fit items-center gap-1.5 text-xs font-medium text-sky-700 hover:underline dark:text-sky-400"
      >
        <LayoutGrid className="size-3.5 shrink-0" aria-hidden />
        Global settings
      </Link>
    </div>
  );
}
